import http from './http';

export async function secondaryGetBadges() {
  const { data } = await http.get('/api/secondary-handler/badges');
  return data;
}

export async function secondaryPageTasks(params) {
  const { data } = await http.get('/api/secondary-handler/tasks/page', { params });
  return data;
}

export async function secondaryTaskRead(id) {
  const { data } = await http.post(`/api/secondary-handler/tasks/${id}/read`);
  return data;
}

export async function secondaryTaskConfirm(id) {
  const { data } = await http.post(`/api/secondary-handler/tasks/${id}/confirm`);
  return data;
}

export async function secondaryTaskReceipt(id, payload) {
  const { data } = await http.post(`/api/secondary-handler/tasks/${id}/receipt`, payload);
  return data;
}

export async function secondaryListAnnouncements() {
  const { data } = await http.get('/api/secondary-handler/announcements');
  return data;
}

export async function secondaryConfirmAnnouncement(id) {
  const { data } = await http.post(`/api/secondary-handler/announcements/${id}/confirm`);
  return data;
}

export async function secondaryPendingCases() {
  const { data } = await http.get('/api/secondary-handler/cases/pending');
  return data;
}

export async function secondarySubmitCase(payload) {
  const { data } = await http.post('/api/secondary-handler/cases/submit', payload);
  return data;
}

export async function secondarySubmittedCases() {
  const { data } = await http.get('/api/secondary-handler/cases/submitted');
  return data;
}

export async function secondaryReturnedCases() {
  const { data } = await http.get('/api/secondary-handler/cases/returned');
  return data;
}

export async function secondaryClosedCases() {
  const { data } = await http.get('/api/secondary-handler/cases/closed');
  return data;
}

export async function secondaryDisputes() {
  const { data } = await http.get('/api/secondary-handler/disputes');
  return data;
}

export async function secondaryTakeDispute(id) {
  const { data } = await http.post(`/api/secondary-handler/disputes/${id}/take`);
  return data;
}

export async function secondaryEscalateDispute(id, payload) {
  const { data } = await http.post(`/api/secondary-handler/disputes/${id}/escalate`, payload);
  return data;
}

export async function secondaryCloseDispute(id, payload) {
  const { data } = await http.post(`/api/secondary-handler/disputes/${id}/reply-close`, payload);
  return data;
}

export async function secondaryCaseDetail(caseNo) {
  const { data } = await http.get(`/api/secondary-handler/cases/${caseNo}`);
  return data;
}

export async function secondaryMarkCaseSeen(caseNo) {
  const { data } = await http.post(`/api/secondary-handler/cases/${caseNo}/seen`);
  return data;
}

export async function secondaryUrgeCase(caseNo) {
  const { data } = await http.post(`/api/secondary-handler/cases/${caseNo}/urge`);
  return data;
}

export async function secondaryReplyEscalate(caseNo, payload) {
  const { data } = await http.post(`/api/secondary-handler/cases/${caseNo}/reply-escalate`, payload);
  return data;
}

export async function secondaryReplyReturn(caseNo, payload) {
  const { data } = await http.post(`/api/secondary-handler/cases/${caseNo}/reply-return`, payload);
  return data;
}

export async function secondaryReplyClose(caseNo, payload) {
  const { data } = await http.post(`/api/secondary-handler/cases/${caseNo}/reply-close`, payload);
  return data;
}

export async function secondaryResubmitCase(caseNo, payload) {
  const { data } = await http.post(`/api/secondary-handler/cases/${caseNo}/resubmit`, payload);
  return data;
}

export async function secondaryCancelCase(caseNo) {
  const { data } = await http.post(`/api/secondary-handler/cases/${caseNo}/cancel`);
  return data;
}

export async function secondaryCreateDispute(caseNo, payload) {
  const { data } = await http.post(`/api/secondary-handler/cases/${caseNo}/dispute`, payload);
  return data;
}

export async function secondaryUrgeDispute(id) {
  const { data } = await http.post(`/api/secondary-handler/disputes/${id}/urge`);
  return data;
}
